import e from"react";import{Content as t,Title as l,Description as r}from"./styles.js";const n=n=>{let{title:m,description:o}=n;return e.createElement(t,null,e.createElement(l,null,m),o&&e.createElement(r,null,o))};export{n as Toast};
//# sourceMappingURL=Toast.js.map
